export default "__VITE_ASSET__87ef75fc__"